/* src/app/app.component.scss */
:host {
  height: 100%;
  margin: 0;
}
/*# sourceMappingURL=app.component-HZCYOUJU.css.map */
